import useAgentData from "../../core/hooks/data/useAgentData";
import useOwnerData from "../../core/hooks/data/useOwnerData";

interface ManagementAgentProps {
  children: React.ReactNode;
}

const ManagementAgentHOC = ({ children }: ManagementAgentProps) => {
  useOwnerData();
  useAgentData();

  return <>{children}</>;
};

export default ManagementAgentHOC;
